import { classNameMerger } from '@breetometer/utils';
import { BreadCrumbs, SettingsWrapper } from 'BreetComponents';

import type { IPinManagementFormWrapper } from './PinManagement.helpers';

const PinManagementFormWrapper = ({ title, children, isModal }: IPinManagementFormWrapper) => (
	<div className={classNameMerger('subbodycontent', !isModal && 'settings-pages')}>
		{!isModal && (
			<BreadCrumbs
				noHome
				pageTitle={title}
			/>
		)}
		<SettingsWrapper isSub>
			{!isModal && (
				<BreadCrumbs
					noHome
					pageTitle={title}
				/>
			)}
			<div className='securityformwrapper'>{children}</div>
		</SettingsWrapper>
	</div>
);

export default PinManagementFormWrapper;
